import util from '../../libs/util'
import router from '../../router'

export default {
  namespaced: true,
  actions: {
    login({dispatch}, {
      username = '',
      password = ''
    } = {}) {
      return new Promise((resolve, reject) => {
        //请求登录接口
        dispatch('load');
        resolve();
      })
    },

    logout({commit, dispatch}, {confirm = false} = {}) {
      async function logout() {
        //删除cookie
        console.log('logout');
        util.db.set('user.username', '').write();
        util.db.set('user.remainday', '').write();
        util.cookies.remove('user.username');
        util.cookies.remove('user.remainday');
        // 清空 vuex 用户信息
        await dispatch('user/set', {}, {root: true});
        // 跳转路由
        router.push({
          name: 'login'
        })
      }

      if (confirm) {
        ELEMENT.MessageBox.confirm('注销当前账户吗?', '确认操作', {
          confirmButtonText: '确定注销',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          logout()
        }).catch(() => {
          ELEMENT.Message({
            message: '取消注销用户'
          })
        })
      } else {
        logout()
      }
    },

    load({dispatch}) {
      return new Promise(async resolve => {
        await dispatch('user/load', null, {root: true})
        resolve()
      })
    },

    clear({commit, dispatch}, param) {
      async function clear() {
        //不清除信息的url
        let notClearPath = ['/analytics/chars'];
        if (!notClearPath.includes(param['route'])) {
          // util.db.set('user.username', '').write();
          // 清空 vuex 用户信息
          // await dispatch('user/set', {}, {root: true});
        }
      }

      clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js